export default {
  //用于输入框限制输入为数字和最多两位的小数；如金额输入框
  bind(el) {
    el.addEventListener('input', function (e) {
      const value = e.target.value
      // 1. 过滤非数字和点字符
      let filtered = value.replace(/[^\d.]/g, '')
      // 2. 限制多个小数点
      filtered = filtered.replace(/\.{2,}/g, '.')
      // 3. 限制小数点后两位
      const pointIndex = filtered.indexOf('.')
      if (pointIndex > -1 && filtered.length - pointIndex > 3) {
        filtered = filtered.substring(0, pointIndex + 3)
      }
      // 4. 更新值（处理开头小数点情况）
      if (filtered.startsWith('.')) {
        filtered = '0' + filtered
      }
      if (value !== filtered) {
        e.target.value = filtered
        e.target.dispatchEvent(new Event('input')) // 触发v-model更新
      }
    })
  }
}
